var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.notifications),function(value,key){return _c('span',{key:key,staticClass:"sw-Flash_MessageBox-alert"},[_vm._v("\n    "+_vm._s(_vm.formatDate(value))+" にサイズ入力されました\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }